module.exports = __webpack_public_path__ + "img/logo.e810bec9.svg";